import React, { useState } from "react";
import "./AppointmentPage.css";
const AppointmentPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    countryCode: "+91",
    phone: "",
    gender: "",
    age: "",
    concern: "",
    otherConcern: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = {
      data: {
        "Name": formData.name,
        "Country code": formData.countryCode,
        "Phone": formData.phone,
        "Gender": formData.gender,
        "Age": formData.age,
        "Main Concern": formData.concern === "Other" ? formData.otherConcern : formData.concern,
        "Timestamp": new Date().toLocaleString(), // optional, or leave blank
      },
    };
    try {
      const response = await fetch("https://sheetdb.io/api/v1/qduwozvr0knt4", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      });
      if (response.ok) {
        alert("Thank you! Your appointment request has been submitted.");
        setFormData({
          name: "",
          countryCode: "+91",
          phone: "",
          gender: "",
          age: "",
          concern: "",
          otherConcern: "",
        });
      } else {
        alert("Error submitting the form. Please try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting the form. Please try again later.");
    }
  };
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <section className="appointment-container">
      <div className="appointment-image">
        <img
          src="https://i.ibb.co/HDcnBZt3/Rectangle-76.png"
          alt="Happy couple in Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
        />
      </div>
      <div className="appointment-form">
        <h2>Reserve Your Consultation</h2>
        <p>
          Simply fill in your details—our staff will quickly follow up to
          schedule your preferred time at Krisara Gastro and Liver Clinic.
        </p>
        <form onSubmit={handleSubmit} style={{ width: "90%" }}>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <div className="phone-row">
            <select
              name="countryCode"
              value={formData.countryCode}
              onChange={handleChange}
              style={{ width: "20%" }}
            >
              <option value="+91">+91</option>
              <option value="+1">+1</option>
              <option value="+44">+44</option>
              <option value="+61">+61</option>
            </select>
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-row">
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              required
            >
              <option value="">Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
            <input
              type="number"
              name="age"
              placeholder="Age"
              value={formData.age}
              onChange={handleChange}
              required
            />
          </div>
          <select
            name="concern"
            value={formData.concern}
            onChange={handleChange}
            required
          >
            <option value="">Main Concern</option>
            <option value="Digestive Issues">Digestive Issues</option>
            <option value="Liver Problems">Liver Problems</option>
            <option value="Endoscopy">Endoscopy</option>
            <option value="Colonoscopy">Colonoscopy</option>
            <option value="Other">Other</option>
          </select>
          {formData.concern === "Other" && (
            <input
              type="text"
              name="otherConcern"
              placeholder="Please specify your concern"
              value={formData.otherConcern}
              onChange={handleChange}
              required
              className="other-concern-input"
            />
          )}
          <button type="submit" className="appointment-btn" style={{ padding: "12px" }}>
            Book Appointment
          </button>
        </form>
      </div>
    </section>
  );
};
export default AppointmentPage;